export const referralConvertPoint =  {
	text: {
		text1: "Vous n'avez aucun point de parrainage.| Vous disposez de 1 point de parrainage. Chaque point vous donne droit à 3 mois gratuits supplémentaire sur votre abonnement, soit un total de {months} mois gratuits.| Vous disposez de {points} points de parrainage. Chaque point vous donne droit à 3 mois gratuits supplémentaires sur votre abonnement, soit un total de {months} mois gratuits.",
		text2: 'Souhaitez-vous convertir vos points maintenant ?',
		text3: '⚠️ Cette opération est irréversible : tous vos points seront utilisés et ajoutés à votre abonnement actuel.',
		text4: 'Votre nouvelle date de fin de licence sera automatiquement mise à jour.',

		// text si le nombre de point depasse 4
		text5: 'Vous pouvez convertir jusqu’à 4 points par an pour bénéficier d’une année gratuite.',
		text6: "Aucun point disponible. | Le point restant sera disponible à partir de l'année prochaine pour une utilisation ultérieure. | Les {count} points restants seront disponibles à partir de l’année prochaine pour une utilisation ultérieure.",
		text7: 'Souhaitez-vous utiliser vos 4 points maintenant ?',
		text8: '⚠️ Cette opération est irréversible : les 4 points sélectionnés seront utilisés et ajoutés à votre abonnement actuel.'
	}
}








